import React, { useEffect } from 'react';

const MomCalendar: React.FC = () => {
  useEffect(() => {
    // 페이지 로드 시 엑셀 파일 다운로드
    const downloadExcel = async () => {
      try {
        // 백엔드 URL 직접 호출
        const backendUrl = 'https://www.hb-volleyball.co.kr/api/mom/calendar';
        const response = await fetch(backendUrl);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        // Blob으로 변환
        const blob = await response.blob();
        
        // Content-Disposition 헤더에서 파일명 추출 시도
        const contentDisposition = response.headers.get('content-disposition');
        let filename = '보육교직원출근부.xlsx';
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1].replace(/['"]/g, '');
            // URL 인코딩된 파일명 디코딩
            try {
              filename = decodeURIComponent(filename);
            } catch (e) {
              // 디코딩 실패 시 원본 사용
            }
          }
        }
        
        // Blob을 파일로 다운로드
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('엑셀 다운로드 실패:', error);
        const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류';
        console.error('상세 에러:', error);
        window.alert(`엑셀 파일 다운로드에 실패했습니다.\n\n에러: ${errorMessage}\n\n브라우저 콘솔을 확인해주세요.`);
      }
    };
    
    downloadExcel();
  }, []);
  
  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh',
      flexDirection: 'column',
      gap: '1rem'
    }}>
      <h2>엑셀 파일을 다운로드하는 중...</h2>
      <p>다운로드가 시작되지 않으면 새로고침해주세요.</p>
    </div>
  );
};

export default MomCalendar;

